<template>
  <div>

    <div v-if="siviMessage">
      <div v-if="attachments.length > 0">
        <button :id="afdMessageId + '-attachment'"
                @click="toggleDisplayDownloadAttachments()" class="btn btn-primary" v-if="!displayDownloadAttachments">
          Toon bijlagen opslaan
        </button>
        <button :id="afdMessageId + '-attachment'"
                @click="toggleDisplayDownloadAttachments()" class="btn btn-primary" v-else>Downloaden verbergen
        </button>
        <div v-if="displayDownloadAttachments">

          <p>Het opslaan doet u per bijlage en staat los van hoe dit bericht wordt verwerkt.</p>
          <div v-for="(attachment, key) in attachments" :key="key">
            <a-collapse v-if="siviMessage.subMessages" style="margin-top: 1.5rem;">
              <a-collapse-panel :header="'Bijlage - ' + attachmentValueByLabel(attachment, 'FILNM')">
                <sivi-entity-component :key="key" :entity="attachment"/>
              </a-collapse-panel>
            </a-collapse>
            <upload-sivi-message-attachment-component :attachment="attachment" :porCode="porCode"
                                                      :messageDate="messageDate"
            style="padding-top: 2rem"></upload-sivi-message-attachment-component>
          </div>
        </div>
      </div>
      <div v-else>
        Er zijn geen bijlagen gevonden bij dit bericht.
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import moment from 'moment';
import store from '../store';
import siviApi from '~/api/sivi';
import SiviEntityComponent from "~/modules/sivi/components/SiviEntityComponent";
import UploadSiviMessageAttachmentComponent from "./UploadSiviMessageAttachmentComponent";
import {DateFormatEnum, SIVIEntityLabelEnum} from "~/enums";

export default {
  name: "SaveSiviMessageAttachmentsComponent",
  props: {
    afdMessageId: {
      type: [String, Number],
      required: true
    },
    sourceSiviMessage: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    policyMessage: {
      type: Object,
      required: true
    },
    attachableSavable: {
      type: Boolean,
      default: false
    },
    saveAttachmentsOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      siviMessage: null,
      displayDownloadAttachments: false,
      attachments: [],
    }
  },
  computed: {
    ...mapGetters({}),
    porCode() {
      if (typeof this.policyMessage.data !== 'undefined' && this.policyMessage.data !== null && this.policyMessage.data.agencyPORCode
      ) {
        return this.policyMessage.data.agencyPORCode
      }
      return null;
    },

    messageDate() {
      if (this.policyMessage.datetime && this.policyMessage.datetime !== '0000-00-00 00:00:00') {
        return moment(this.policyMessage).format(DateFormatEnum.DISPLAY_DATE);
      }
      return null;
    }

  },
  created() {
    const STORE_KEY = '$_search';
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }

    if (this.siviMessage === null && this.afdMessageId === null) {
      throw new Error('Either the sivi message or the afd message id must be provided via the props')
    } else if (this.sourceSiviMessage !== null) {
      this.siviMessage = this.sourceSiviMessage
    }
  },
  mounted() {
    if (this.siviMessage === null) {
      siviApi.getByAfdMessageId(this.afdMessageId).then((data) => {
        this.siviMessage = data.data;

        this.extractAttachments(this.siviMessage)

      })
    }
    this.displayDownloadAttachments = this.saveAttachmentsOpen
  },
  components: {
    SiviEntityComponent,
    UploadSiviMessageAttachmentComponent
  },
  methods: {
    toggleDisplayDownloadAttachments() {
      this.displayDownloadAttachments = !this.displayDownloadAttachments
    },

    extractAttachments(siviMessage) {

      if (siviMessage.entities.length > 0) {
        siviMessage.entities.forEach(entity => {
          entity.entities.forEach(subEntity => {
            if (subEntity.label === SIVIEntityLabelEnum.ATTACHMENT) {
              this.attachments.push(subEntity)
            }
            if (subEntity.entities.length > 0) {
              if ((subEntity.entities && subEntity.entities.length > 0) || (subEntity.subMessages && subEntity.subMessages.length > 0)) {
                this.extractAttachments(subEntity)
              }
            }
          })
        })
      }

      if (siviMessage.subMessages.length > 0) {
        siviMessage.subMessages.forEach(subMessage => {
          this.extractAttachments(subMessage)
        })
      }

    },

    attachmentValueByLabel(attachment, attributeLabel) {
      var value = '';

      attachment.attributes.forEach(attribute => {
        if (attribute.label === attributeLabel) {
          value = attribute.value;
        }
      })
      return value;
    }
  }
}
</script>

<style scoped>
.csv-export-component {
}

table.table th, table.table td {
  padding: 1.5rem 1rem;
}

</style>
